/* eslint-disable react/no-array-index-key */
import { useState , useEffect } from 'react'
import styles from './styles.module.sass'

const Brands = (props) => {
    const {
        brands,
        setListBrands,
        actualFilters,
        resetFilters,
        singleSelector = false
    } = props


    const [ verMas, setVerMas ] = useState(false)
    const [ typeComponent, setTypeComponent ] = useState('checkbox')
    const [ activeBrands, setActiveBrands ] = useState(actualFilters?.brands)
    
    const handleClick = (val) => {
        const brand = val

        if(!singleSelector){
            if( activeBrands.includes(brand) ){
                setActiveBrands(prevArray => prevArray.filter(valor => valor !== brand ) )
            }else{
                setActiveBrands(prevArray => [...prevArray, brand] )
            }
        }
        else{
            // eslint-disable-next-line no-lonely-if
            if( activeBrands.includes(brand) ){
                setActiveBrands([])
            }else{
                setActiveBrands( [brand] )
            }
        }
    }

    useEffect(()=>{
        if(singleSelector){
            setTypeComponent('checkbox')
        }
    },[singleSelector])

    useEffect(()=>{
        setListBrands(activeBrands)
    },[activeBrands])

    useEffect(()=>{
        if(resetFilters){
            setActiveBrands([])
        }
    },[resetFilters])


    return(
        <div className={styles?.contenidoCategorias}>

            <div className={styles?.seccionSuperior}>
                <p className={styles?.h2}>Marcas</p>
            </div>

            <div className={styles?.iteracion}>
                <ul>
                    {Object.entries(brands)?.map(([lvl0], index) => (
                        verMas === false
                            ? index <= 4 &&
                                <li key={`categ_${index}`} className={styles?.listTitles}>
                                    <label 
                                        className={styles?.labelClass} 
                                        htmlFor={`lvl0_${lvl0}`}
                                    >{lvl0}</label>
                                    <input
                                        className={styles?.radio} 
                                        type={typeComponent}
                                        name="brand"
                                        id={`lvl0_${lvl0}`} 
                                        onChange={() => handleClick(`${lvl0}`)}
                                        checked={ String(activeBrands.filter(valor => valor === lvl0)) === lvl0 }
                                    />
                                </li>
                            : (
                                <li key={`categ_${index}`} className={styles?.listTitles}>
                                    <label 
                                        className={styles?.labelClass} 
                                        htmlFor={`lvl0_${lvl0}`}
                                    >{lvl0}</label>
                                    <input 
                                        className={styles?.radio} 
                                        type={typeComponent}
                                        name="brand"
                                        id={`lvl0_${lvl0}`} 
                                        onChange={() => handleClick(`${lvl0}`)} 
                                        checked={ String(activeBrands.filter(valor => valor === lvl0)) === lvl0 }   
                                    />
                                </li>
                            )
                        ))}
                </ul>
                {Object.entries(brands)?.length > 5
                    ?
                        <div className={styles?.boxVerMasCategorias}>
                            {verMas === false
                                ? <p onClick={() => setVerMas(!verMas)} aria-hidden="true" className="textoVerMas"> Ver más</p>
                                : <p onClick={() => setVerMas(!verMas)} aria-hidden="true" className="textoVerMenos"> Ver menos</p>
                            }
                        </div>
                    : null
                }
            </div>
        </div>
    )   
}

export default Brands